/** @format */

export default {
	props: {
		showPagination: {
			type: Boolean,
			default: true,
		},
		paginationOptions: {
			type: Object,
			default: () => {
				return {
					pagerCount: 5,
					pageSizes: [10, 20, 50, 100],
					layout: 'prev, pager, next, jumper,sizes, ->,slot',
				};
			},
		},
		totalKey: {
			// 总记录
			type: String,
			default: 'totalCount',
		},
		pageKey: {
			// 当前页数
			type: String,
			default: 'page',
		},
		pageSizeKey: {
			// 分页大小
			type: String,
			default: 'limit',
		},
		pageCountKey: {
			// 总页数
			type: String,
			default: 'totalPages',
		},
		/**
		 * @description 表格分页数据
		 */
		pagination: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	computed: {
		currentPage: {
			get() {
				return this.pagination[this.pageKey] || 1;
			},
			set(val) {
				this.handlePaginationCurrentChange(val);
			},
		},
		pageSize() {
			return this.pagination[this.pageSizeKey] || 20;
		},
		/**
		 * 是否显示分页
		 */
		isShowPagination() {
			if (!this.showPagination) return false;
			if (this.$slots.footer) return true;
			return !!this.pagination;
		},
	},
	methods: {
		/**
		 * @description 每页条数改变
		 */
		handlePaginationSizeChange(pageSize) {
			this.handlePaginationChange({
				[this.pageSizeKey]: pageSize,
				[this.pageKey]: 1,
			});
		},
		/**
		 * @description 当前页码改变
		 */
		handlePaginationCurrentChange(currentPage) {
			this.handlePaginationChange({
				[this.pageSizeKey]: this.pageSize,
				[this.pageKey]: currentPage,
			});
		},
		/**
		 * @description 上一页
		 */
		handlePaginationPrevClick(currentPage) {
			this.handlePaginationChange({
				[this.pageSizeKey]: this.pageSize,
				[this.pageKey]: currentPage,
			});
		},
		/**
		 * @description 下一页
		 */
		handlePaginationNextClick(currentPage) {
			this.handlePaginationChange({
				[this.pageSizeKey]: this.pageSize,
				[this.pageKey]: currentPage,
			});
		},
		handlePaginationChange(params) {
			const pageSize = params[this.pageSizeKey];
			const currentPage = params[this.pageKey];
			if (pageSize === this.pageSize && currentPage === this.currentPage) {
				return;
			}
			// this.$set('this.pagination',this.pageSizeKey)
			this.$emit('pagination-change', {
				[this.pageSizeKey]: pageSize || this.pageSize,
				[this.pageKey]: currentPage || this.currentPage,
			});
		},
		/**
		 * 分页刷新
		 */
		handlePaginationRefresh() {
			this.handleActionEvent({ code: 'resetSearch' });
		},
	},
};
